import Nav from "@/components/Nav";
import Hero from "@/components/sections/Hero";
import PendulumTeaser from "@/components/sections/PendulumTeaser";
import About from "@/components/sections/About";
import Support from "@/components/sections/Support";
import Tarot from "@/components/sections/Tarot";
import Shop from "@/components/sections/Shop";
import Booking from "@/components/sections/Booking";
import Footer from "@/components/sections/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import DailyTarotModal from "@/components/DailyTarotModal";

export default function Landing() {
  return (
    <>
      <DailyTarotModal />
      <Nav />
      <main>
        <Hero />
        <PendulumTeaser />
        <About />
        <Support />
        <Tarot />
        <Shop />
        <Booking />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}
